import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
var _excluded = ["color", "variant"],
  _excluded2 = ["color", "variant"],
  _excluded3 = ["color", "variant"],
  _excluded4 = ["color", "variant"],
  _excluded5 = ["color", "variant"],
  _excluded6 = ["color", "variant"],
  _excluded7 = ["color", "variant"],
  _excluded8 = ["color", "variant"],
  _excluded9 = ["color", "variant"],
  _excluded10 = ["color"],
  _excluded11 = ["color"],
  _excluded12 = ["color"],
  _excluded13 = ["color"],
  _excluded14 = ["color"],
  _excluded15 = ["color"],
  _excluded16 = ["color"],
  _excluded17 = ["color", "variant"],
  _excluded18 = ["color"],
  _excluded19 = ["color"],
  _excluded20 = ["color", "variant"],
  _excluded21 = ["color", "variant"],
  _excluded22 = ["color"],
  _excluded23 = ["color"],
  _excluded24 = ["color"],
  _excluded25 = ["color"],
  _excluded26 = ["color"],
  _excluded27 = ["color"],
  _excluded28 = ["color"],
  _excluded29 = ["color"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import ApplicationIcon from "../../icons/Application";
import ApplyBoostIcon from "../../icons/ApplyBoost";
import ApplyBoardLogo from "../../icons/ApplyBoardLogo";
import ArrowChevronDown from "../../icons/ArrowChevronDown";
import ArrowChevronRight from "../../icons/ArrowChevronRight";
import ArrowChevronUp from "../../icons/ArrowChevronUp";
import ArrowNext from "../../icons/ArrowNext";
import BookOutlineIcon from "../../icons/BookOutlineIcon";
import BuildingsOutlineIcon from "../../icons/BuildingsOutlineIcon";
import BuildingOutlineIcon from "../../icons/BuildingOutlineIcon";
import CalculatorOutlineIcon from "../../icons/CalculatorOutlineIcon";
import CalendarDateStartOutline from "../../icons/CalendarDateStartOutline";
import CategoriesOutlineIcon from "../../icons/CategoriesOutlineIcon";
import CityPersonOutlineIcon from "../../icons/CityPersonOutlineIcon";
import ClipboardOutlineIcon from "../../icons/ClipboardOutlineIcon";
import CloseOutlineIcon from "../../icons/CloseOutlineIcon";
import CheckCircleIcon from "../../icons/CheckCircleIcon";
import CheckMarkMulti from "../../icons/CheckMarkMulti";
import CheckMarkOutline from "../../icons/CheckMarkOutline";
import DocumentCheckOutline from "../../icons/DocumentCheckOutline";
import DownloadOutlineIcon from "../../icons/DownloadOutlineIcon";
import EditFillIcon from "../../icons/EditFill";
import EmailIcon from "../../icons/Email";
import Ellipsis from "../../icons/Ellipsis";
import ErrorOutlineIcon from "../../icons/ErrorOutlineIcon";
import FlagOutlineIcon from "../../icons/FlagOutlineIcon";
import FilterFillIcon from "../../icons/FilterFill";
import FilterOutlineIcon from "../../icons/FilterOutline";
import FormatListBulleted from "../../icons/FormatListBulleted";
import HelpOutline from "../../icons/HelpOutline";
import ImportOutlineIcon from "../../icons/ImportOutlineIcon";
import InfoOutlineIcon from "../../icons/InfoOutlineIcon";
import LinkOutline from "../../icons/LinkOutline";
import MessageAddOutlineIcon from "../../icons/MessageAddOutlineIcon";
import MoneyDollarOutlineIcon from "../../icons/MoneyDollarOutlineIcon";
import NewReleasesOutlineIcon from "../../icons/NewReleasesOutlineIcon";
import NewspaperOutline from "../../icons/NewspaperOutline";
import Number from "../../icons/Number";
import PeopleOutlineIcon from "../../icons/PeopleOutline";
import PersonFillIcon from "../../icons/PersonFill";
import PersonOutlineIcon from "../../icons/PersonOutline";
import PersonTieRelationshipOutlineIcon from "../../icons/PersonTieRelationshipOutlineIcon";
import PlaceOutlineIcon from "../../icons/PlaceOutlineIcon";
import PlusFillIcon from "../../icons/PlusFill";
import PlusOutlineIcon from "../../icons/PlusOutline";
import PhoneIcon from "../../icons/Phone";
import Text from "../../icons/Text";
import TrainHubLogo from "../../icons/TrainHub";
import InfoFillIcon from "../../icons/InfoFillIcon";
import SearchOutlineIcon from "../../icons/SearchOutline";
import SearchFillIcon from "../../icons/SearchFill";
import SocialFacebookIcon from "../../icons/SocialFacebookIcon";
import SocialLinkedinOutlineIcon from "../../icons/SocialLinkedinOutlineIcon";
import SocialTwitterFillIcon from "../../icons/SocialTwitterFillIcon";
import SpeakerOutlineIcon from "../../icons/SpeakerOutlineIcon";
import StudentCheckOutlineIcon from "../../icons/StudentCheckOutlineIcon";
import TestimonialOutlineIcon from "../../icons/TestimonialOutlineIcon";
import WarningFillIcon from "../../icons/WarningFill";
import WarningOutlineIcon from "../../icons/WarningOutline";
import FireOutlineIcon from "../../icons/FireOutline";
import AccountCircleOutline from "../../icons/AccountCircleOutline";
import AccountCircleFill from "../../icons/AccountCircleFill";
import ListBoxesOutline from "../../icons/ListBoxesOutline";
import ListChecksOutline from "../../icons/ListChecksOutline";
import Condition from "../../icons/ConditionIcon";
import DocumentFill from "../../icons/DocumentFill";
import HomeOutline from "../../icons/HomeOutline";
import HomeFill from "../../icons/HomeFill";
import MoneyDollarCheckOutline from "../../icons/MoneyDollarCheckOutline";
import MoneyDollarFill from "../../icons/MoneyDollarFill";
import PersonCheckOutline from "../../icons/PersonCheckOutline";
import PersonTieFill from "../../icons/PersonTieFill";
import PersonTieOutline from "../../icons/PersonTieOutline";
import ListStarsOutline from "../../icons/ListStarsOutline";
import StudentFill from "../../icons/StudentFill";
import StudentOutlineIcon from "../../icons/StudentOutline";
import FlagFill from "../../icons/FlagFill";
import Menu from "../../icons/Menu";
import ArrowBack from "../../icons/ArrowBack";
import MagnifyingGlassIcon from "../../icons/MagnifyingGlass";
import SortDescendingIcon from "../../icons/SortDescendingIcon";
import DocumentOutline from "../../icons/DocumentOutline";
import DeleteOutline from "../../icons/DeleteOutline";
import EditOutline from "../../icons/EditOutline";
import { AMBER, BLUE, GRAY, GREEN, RED } from "../../constants/colors/hex";
function colorSelector(color) {
  switch (color) {
    case 'amber':
      return AMBER[12];
    case 'blue':
      return BLUE[10];
    case 'gray':
      return GRAY[10];
    case 'green':
      return GREEN[11];
    case 'red':
      return RED[9];
    case 'black':
    case 'white':
      return color;
    default:
      return 'black';
  }
}
var DEFAULT_PROPS = {
  color: 'white',
  variant: 'outline'
};
export var AccountIcon = function AccountIcon(_ref) {
  var color = _ref.color,
    variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded);
  var Component = variant === 'fill' ? AccountCircleFill : AccountCircleOutline;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
AccountIcon.defaultProps = DEFAULT_PROPS;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var BoxListIcon = function BoxListIcon(_ref2) {
  var color = _ref2.color,
    variant = _ref2.variant,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var Component = ListBoxesOutline;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
BoxListIcon.defaultProps = DEFAULT_PROPS;
export var SearchIcon = function SearchIcon(_ref3) {
  var color = _ref3.color,
    variant = _ref3.variant,
    props = _objectWithoutProperties(_ref3, _excluded3);
  var Component = variant === 'fill' ? SearchFillIcon : SearchOutlineIcon;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
SearchIcon.defaultProps = DEFAULT_PROPS;
export var DocumentIcon = function DocumentIcon(_ref4) {
  var color = _ref4.color,
    variant = _ref4.variant,
    props = _objectWithoutProperties(_ref4, _excluded4);
  var Component = variant === 'fill' ? DocumentFill : DocumentOutline;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
DocumentIcon.defaultProps = DEFAULT_PROPS;
export var FilterIcon = function FilterIcon(_ref5) {
  var color = _ref5.color,
    variant = _ref5.variant,
    props = _objectWithoutProperties(_ref5, _excluded5);
  var Component = variant === 'fill' ? FilterFillIcon : FilterOutlineIcon;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
FilterIcon.defaultProps = DEFAULT_PROPS;
export var StudentIcon = function StudentIcon(_ref6) {
  var color = _ref6.color,
    variant = _ref6.variant,
    props = _objectWithoutProperties(_ref6, _excluded6);
  var Component = variant === 'fill' ? StudentFill : StudentOutline;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
StudentIcon.defaultProps = DEFAULT_PROPS;
export var MoneyDollarIcon = function MoneyDollarIcon(_ref7) {
  var color = _ref7.color,
    variant = _ref7.variant,
    props = _objectWithoutProperties(_ref7, _excluded7);
  var Component = variant === 'fill' ? MoneyDollarFill : MoneyDollarCheckOutline;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
MoneyDollarIcon.defaultProps = DEFAULT_PROPS;
export var PersonTieIcon = function PersonTieIcon(_ref8) {
  var color = _ref8.color,
    variant = _ref8.variant,
    props = _objectWithoutProperties(_ref8, _excluded8);
  var Component = variant === 'fill' ? PersonTieFill : PersonTieOutline;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
PersonTieIcon.defaultProps = DEFAULT_PROPS;
export var HomeIcon = function HomeIcon(_ref9) {
  var color = _ref9.color,
    variant = _ref9.variant,
    props = _objectWithoutProperties(_ref9, _excluded9);
  var Component = variant === 'fill' ? HomeFill : HomeOutline;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
HomeIcon.defaultProps = DEFAULT_PROPS;
export var ListStarsIcon = function ListStarsIcon(_ref10) {
  var color = _ref10.color,
    props = _objectWithoutProperties(_ref10, _excluded10);
  var Component = ListStarsOutline;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
ListStarsIcon.defaultProps = DEFAULT_PROPS;
export var ListCheckIcon = function ListCheckIcon(_ref11) {
  var color = _ref11.color,
    props = _objectWithoutProperties(_ref11, _excluded11);
  var Component = ListChecksOutline;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
ListCheckIcon.defaultProps = DEFAULT_PROPS;
export var ConditionIcon = function ConditionIcon(_ref12) {
  var color = _ref12.color,
    props = _objectWithoutProperties(_ref12, _excluded12);
  var Component = Condition;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
ConditionIcon.defaultProps = DEFAULT_PROPS;
export var ImportIcon = function ImportIcon(_ref13) {
  var color = _ref13.color,
    props = _objectWithoutProperties(_ref13, _excluded13);
  var Component = ImportOutlineIcon;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
ImportIcon.defaultProps = DEFAULT_PROPS;
export var PersonCheckIcon = function PersonCheckIcon(_ref14) {
  var color = _ref14.color,
    props = _objectWithoutProperties(_ref14, _excluded14);
  var Component = PersonCheckOutline;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
PersonCheckIcon.defaultProps = DEFAULT_PROPS;
export var HamburgerMenuIcon = function HamburgerMenuIcon(_ref15) {
  var color = _ref15.color,
    props = _objectWithoutProperties(_ref15, _excluded15);
  var Component = Menu;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
HamburgerMenuIcon.defaultProps = DEFAULT_PROPS;
export var ArrowBackIcon = function ArrowBackIcon(_ref16) {
  var color = _ref16.color,
    props = _objectWithoutProperties(_ref16, _excluded16);
  var Component = ArrowBack;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
ArrowBackIcon.defaultProps = DEFAULT_PROPS;
export var FlagIcon = function FlagIcon(_ref17) {
  var color = _ref17.color,
    variant = _ref17.variant,
    props = _objectWithoutProperties(_ref17, _excluded17);
  var Component = variant === 'fill' ? FlagFill : FlagOutlineIcon;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
FlagIcon.defaultProps = DEFAULT_PROPS;
export var Edit = function Edit(_ref18) {
  var _ref18$color = _ref18.color,
    color = _ref18$color === void 0 ? 'white' : _ref18$color,
    _ref18$variant = _ref18.variant,
    variant = _ref18$variant === void 0 ? 'outline' : _ref18$variant;
  var Component = variant === 'fill' ? EditFillIcon : EditOutline;
  return /*#__PURE__*/React.createElement(Component, {
    fill: colorSelector(color)
  });
};
export var Search = function Search(_ref19) {
  var _ref19$color = _ref19.color,
    color = _ref19$color === void 0 ? 'white' : _ref19$color,
    _ref19$variant = _ref19.variant,
    variant = _ref19$variant === void 0 ? 'outline' : _ref19$variant;
  var Component = variant === 'fill' ? SearchFillIcon : SearchOutlineIcon;
  return /*#__PURE__*/React.createElement(Component, {
    fill: colorSelector(color)
  });
};
export var Plus = function Plus(_ref20) {
  var _ref20$color = _ref20.color,
    color = _ref20$color === void 0 ? 'white' : _ref20$color,
    _ref20$variant = _ref20.variant,
    variant = _ref20$variant === void 0 ? 'outline' : _ref20$variant;
  var Component = variant === 'fill' ? PlusFillIcon : PlusOutlineIcon;
  return /*#__PURE__*/React.createElement(Component, {
    fill: colorSelector(color)
  });
};
export var Phone = function Phone(_ref21) {
  var _ref21$color = _ref21.color,
    color = _ref21$color === void 0 ? 'white' : _ref21$color,
    props = _objectWithoutProperties(_ref21, _excluded18);
  var Component = PhoneIcon;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
export var Email = function Email(_ref22) {
  var _ref22$color = _ref22.color,
    color = _ref22$color === void 0 ? 'white' : _ref22$color,
    props = _objectWithoutProperties(_ref22, _excluded19);
  var Component = EmailIcon;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
export var Person = function Person(_ref23) {
  var _ref23$color = _ref23.color,
    color = _ref23$color === void 0 ? 'white' : _ref23$color,
    _ref23$variant = _ref23.variant,
    variant = _ref23$variant === void 0 ? 'outline' : _ref23$variant,
    props = _objectWithoutProperties(_ref23, _excluded20);
  var Component = variant === 'fill' ? PersonFillIcon : PersonOutlineIcon;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
export var Warning = function Warning(_ref24) {
  var _ref24$color = _ref24.color,
    color = _ref24$color === void 0 ? 'white' : _ref24$color,
    _ref24$variant = _ref24.variant,
    variant = _ref24$variant === void 0 ? 'outline' : _ref24$variant,
    props = _objectWithoutProperties(_ref24, _excluded21);
  var Component = variant === 'fill' ? WarningFillIcon : WarningOutlineIcon;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
export var ApplyBoost = function ApplyBoost(_ref25) {
  var _ref25$color = _ref25.color,
    color = _ref25$color === void 0 ? 'white' : _ref25$color,
    props = _objectWithoutProperties(_ref25, _excluded22);
  var Component = ApplyBoostIcon;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
export var ApplyBoardLogoIcon = function ApplyBoardLogoIcon(_ref26) {
  var _ref26$color = _ref26.color,
    color = _ref26$color === void 0 ? 'white' : _ref26$color,
    props = _objectWithoutProperties(_ref26, _excluded23);
  var Component = ApplyBoardLogo;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
export var Application = function Application(_ref27) {
  var _ref27$color = _ref27.color,
    color = _ref27$color === void 0 ? 'white' : _ref27$color,
    props = _objectWithoutProperties(_ref27, _excluded24);
  var Component = ApplicationIcon;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
export var MagnifyingGlass = function MagnifyingGlass(_ref28) {
  var _ref28$color = _ref28.color,
    color = _ref28$color === void 0 ? 'white' : _ref28$color,
    props = _objectWithoutProperties(_ref28, _excluded25);
  var Component = MagnifyingGlassIcon;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
export var FireOutline = function FireOutline(_ref29) {
  var color = _ref29.color,
    props = _objectWithoutProperties(_ref29, _excluded26);
  var Component = FireOutlineIcon;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
FireOutline.defaultProps = DEFAULT_PROPS;
export var PeopleOutline = function PeopleOutline(_ref30) {
  var _ref30$color = _ref30.color,
    color = _ref30$color === void 0 ? 'white' : _ref30$color,
    props = _objectWithoutProperties(_ref30, _excluded27);
  var Component = PeopleOutlineIcon;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
export var StudentOutline = function StudentOutline(_ref31) {
  var _ref31$color = _ref31.color,
    color = _ref31$color === void 0 ? 'white' : _ref31$color,
    props = _objectWithoutProperties(_ref31, _excluded28);
  var Component = StudentOutlineIcon;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
export var TrainHubLogoIcon = function TrainHubLogoIcon(_ref32) {
  var _ref32$color = _ref32.color,
    color = _ref32$color === void 0 ? 'white' : _ref32$color,
    props = _objectWithoutProperties(_ref32, _excluded29);
  var Component = TrainHubLogo;
  return /*#__PURE__*/React.createElement(Component, _extends({
    fill: colorSelector(color)
  }, props));
};
export { ArrowChevronDown, ArrowChevronRight, ArrowChevronUp, ArrowNext, BookOutlineIcon, BuildingOutlineIcon, BuildingsOutlineIcon, CalculatorOutlineIcon, CalendarDateStartOutline, CategoriesOutlineIcon, CheckCircleIcon, CheckMarkMulti, CheckMarkOutline, CityPersonOutlineIcon, ClipboardOutlineIcon, CloseOutlineIcon as CloseIcon, DeleteOutline, DocumentCheckOutline, DocumentOutline, DownloadOutlineIcon, EditOutline, EmailIcon, Ellipsis, ErrorOutlineIcon, FlagOutlineIcon, FormatListBulleted, HelpOutline, ImportOutlineIcon, InfoFillIcon, InfoOutlineIcon as InfoIcon, LinkOutline, MessageAddOutlineIcon, MoneyDollarOutlineIcon, NewReleasesOutlineIcon, NewspaperOutline, Number, PeopleOutlineIcon, PhoneIcon, PlaceOutlineIcon, PersonTieRelationshipOutlineIcon, SocialFacebookIcon, SocialLinkedinOutlineIcon, SocialTwitterFillIcon, SortDescendingIcon, SpeakerOutlineIcon, StudentCheckOutlineIcon, TestimonialOutlineIcon, Text };